module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("入驻平台")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  如何加入作品有声化平台？")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "592px",
      "height": "329px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_2.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("首先，注册账号，在【我有作品】页面，点击【立即入驻】按钮开始入驻。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "582px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_3.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("按照要求填写个人或机构信息资料，并提交审核。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  加入作品有声化平台，我需要提供什么？")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v(" 如果你是作家，你需要提供个人真实身份信息以及联络方式。"), _c('br'), _vm._v("\n        如果你代表版权机构，你需要提供机构注册信息以及联络方式。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d484b178!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/helpCenter/HelpCenterCopyrighterSignIn.vue
// module id = 554
// module chunks = 0